module.exports = __webpack_public_path__ + "static/media/tooltip.0b860776.svg";